"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableActions = void 0;

var icons_1 = require("@ant-design/icons");

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var ActionContainer = styled_components_1["default"].div(_templateObject());
var TableActionItem = styled_components_1["default"].div(_templateObject2());

var TableActions = function TableActions(_ref) {
  var overlay = _ref.overlay;
  if (!overlay) return null;
  return react_1["default"].createElement(ActionContainer, null, react_1["default"].createElement(antd_1.Dropdown, {
    overlay: overlay,
    arrow: true,
    placement: 'bottomRight'
  }, react_1["default"].createElement(TableActionItem, null, "Actions ", react_1["default"].createElement(icons_1.CaretDownOutlined, {
    style: {
      fontSize: 20
    }
  }))));
};

exports.TableActions = TableActions;